import Feature from "./Feature";

export default function FeaturesGrid({items, bodyColor = 'white'}) {
    if (items.length % 3 === 0) {
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 md:gap-x-12 gap-y-12 md:gap-y-20">
                {items.map(({title, body, icon}, key) => {
                    return (
                        <Feature title={title}
                                 body={body}
                                 bodyColor={bodyColor}
                                 icon={icon}
                                 key={`Feature: ${key}`}
                        />
                    )
                })}
            </div>
        )
    }


    // If not divisible by 3, we need to break the items array into chunks of 3-2-2
    const rows = [];
    items.forEach((item, key) => {
        if (key < 3) {
            if (rows[0] === undefined) {
                rows[0] = [];
            }
            rows[0].push(item);
        } else {
            const row = Math.floor((key - 1) / 2);
            if (rows[row] === undefined) {
                rows[row] = [];
            }
            rows[row].push(item);
        }
    });

    return (
        <div className="flex flex-col gap-y-12 md:gap-y-20">
            {rows.map((row, key) => {
                return (
                    <div key={`FeaturesGridRow: ${key}`}
                         className="flex gap-x-4 md:gap-x-12 justify-center"
                    >
                        {row.map(({title, body, icon}, key) => {
                            return (
                                <Feature title={title}
                                         body={body}
                                         bodyColor={bodyColor}
                                         icon={icon}
                                         key={`Feature: ${key}`}
                                />
                            )
                        })}
                    </div>
                )
            })}
        </div>
    )
}
